import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import IconDefault from './IconDefault';
import IconWrapper from './components/IconWrapper';
const StyledIconDefault = styled(IconDefault)`
  transition: transform 0.3s ease-in-out;
  ${({
  $rotated,
  $direction
}) => $rotated && `
    transform: rotate(${$direction === 'inverse' ? '-180deg' : '180deg'});
  `}
`;
const IconWithRotation = ({
  direction = 'default',
  flex = true,
  pointer = false,
  rotated = false,
  disabled = false,
  inactive = false,
  hasArrow = false,
  hasClose = false,
  icon,
  color,
  colorHover,
  arrow = 'right',
  className,
  style,
  ...props
}) => /*#__PURE__*/React.createElement(IconWrapper, {
  flex: flex,
  pointer: pointer,
  disabled: disabled,
  inactive: inactive,
  className: className,
  style: style
}, /*#__PURE__*/React.createElement(StyledIconDefault, _extends({
  $direction: direction,
  $rotated: rotated,
  pointer: pointer,
  disabled: disabled,
  inactive: inactive,
  hasArrow: hasArrow,
  hasClose: hasClose,
  icon: icon,
  color: color,
  colorHover: colorHover,
  arrow: arrow,
  flex: flex
}, props)));
export default IconWithRotation;